import { Box } from "@material-ui/core";

import { useStyles } from "../../quoteDetail.styles";
import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { TopBox } from "../../../../components/TopBox";
import { QuoteQuotation } from "./QuoteQuotation";
import { BotBox } from "../../../../components/BotBox";
import { quoteTypeName } from "../../../../app/utils";

export const QuoteQuotationSection = ({ quote }: { quote: Quote }) => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  const classes = useStyles();

  return (
    <Box bgcolor="#f7f7f7" mt={"97px"} position={"relative"}>
      <TopBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      <Box
        textAlign={"center"}
        fontSize={isMoreThanSm ? "28px" : "24px"}
        color={"#1e073f"}
        fontWeight={500}
        width={"100%"}
        position={"absolute"}
        top={"67px"}
      >
        Your {quoteTypeName(quote.type)} <span className={classes.colorOrange}>quotation</span>
      </Box>
      <QuoteQuotation quote={quote} />
      <BotBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
    </Box>
  );
};
